import styled from 'styled-components';

const base = styled.div`
  margin: 1rem;
`;

const Frame = {
  Base: base,
};

export default Frame;
